import React, { useState } from 'react';
import './Onboarding.css';

const STEPS = [
  {
    key: 'welcome',
    title: 'Welcome to Heart Felt Souls',
    subtitle: 'Your AI companion for preserving what matters most',
    body: 'Heart Felt Souls captures your voice, stories, and personality — creating a living memory that future generations can return to.',
    icon: '✦',
  },
  {
    key: 'personality',
    title: 'Meet Your Soul',
    subtitle: 'Choose how your AI companion communicates',
    body: null, // custom render
    icon: '◎',
  },
  {
    key: 'memory',
    title: 'How Memories Work',
    subtitle: 'The more you share, the more your Soul remembers',
    body: 'Every conversation helps build your memory graph — a living map of your experiences, relationships, and wisdom. Your Soul learns who you are over time.',
    icon: '◈',
  },
  {
    key: 'privacy',
    title: 'Your Privacy Matters',
    subtitle: 'Your memories belong to you',
    body: 'All conversations are encrypted. Your data is never shared or used for advertising. You can export or delete everything at any time from Settings.',
    icon: '◇',
  },
];

function Onboarding({ selectedModel, onSelectModel, onComplete }) {
  const [step, setStep] = useState(0);
  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;

  const next = () => {
    if (isLast) {
      onComplete();
    } else {
      setStep(s => s + 1);
    }
  };

  const back = () => {
    if (step > 0) setStep(s => s - 1);
  };

  const renderPersonalityStep = () => (
    <div className="ob-personalities">
      <div
        className={`ob-persona ${selectedModel === 'Echo' ? 'ob-persona-active' : ''}`}
        onClick={() => onSelectModel('Echo')}
      >
        <img src="fun-icon.png" alt="Legacy" className="ob-persona-img" />
        <div className="ob-persona-name">Legacy</div>
        <div className="ob-persona-desc">Warm and supportive. Best for relaxed chats about relationships and self-reflection.</div>
      </div>
      <div
        className={`ob-persona ${selectedModel === 'Synth' ? 'ob-persona-active' : ''}`}
        onClick={() => onSelectModel('Synth')}
      >
        <img src="philosophical-icon.png" alt="Story" className="ob-persona-img" />
        <div className="ob-persona-name">Story</div>
        <div className="ob-persona-desc">Thoughtful and deep. Best for preserving memories and reflecting on life experiences.</div>
      </div>
    </div>
  );

  return (
    <div className="ob-overlay">
      <div className="ob-card">
        {/* Progress dots */}
        <div className="ob-dots">
          {STEPS.map((_, i) => (
            <div key={i} className={`ob-dot ${i === step ? 'ob-dot-active' : i < step ? 'ob-dot-done' : ''}`} />
          ))}
        </div>

        {/* Icon */}
        <div className="ob-icon">{current.icon}</div>

        {/* Content */}
        <h2 className="ob-title">{current.title}</h2>
        <p className="ob-subtitle">{current.subtitle}</p>

        {current.key === 'personality' ? renderPersonalityStep() : (
          <p className="ob-body">{current.body}</p>
        )}

        {/* Actions */}
        <div className="ob-actions">
          {step > 0 && (
            <button className="ob-btn-back" onClick={back}>Back</button>
          )}
          <button className="ob-btn-next" onClick={next}>
            {isLast ? "Let's Begin" : 'Continue'}
          </button>
        </div>

        {/* Skip */}
        <button className="ob-skip" onClick={onComplete}>
          Skip intro
        </button>
      </div>
    </div>
  );
}

export default Onboarding;
